import { combineReducers } from 'redux';

import auth from './auth';
import collections from './collections';
import contacts from './contacts';
import transactions from './transactions';
import items from './items';

export default combineReducers({
  auth,
  collections,
  contacts,
  transactions,
  items,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/allReducers.js